import z, { ZodIssueCode } from "zod";
import { fevereiro29 } from '../../../domain/models/periodo_anual';

const dataPeriodo = z.preprocess(
  value => value === null || value === '' ? undefined : value,
  z.coerce.date({ required_error: 'Informe um dia/mês válido!', invalid_type_error: 'Informe um dia/mês válido!' })
    .refine(value => !fevereiro29(value), 'Fevereiro termina em 28/02 nos períodos anuais.')
);

/**
 * CadastroCoresSchema
 */

export const CadastroCoresSchema = z.object({
  dataCadastro: z.coerce.date({ required_error: 'Este campo deve ser preenchido!', invalid_type_error: 'Este campo deve ser preenchido!' }),
  dataInicio: dataPeriodo,
  dataTermino: dataPeriodo,
  idCor: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  cor: z.string().optional(),
  corValor: z.string().optional(),
}).superRefine((data, ctx) => {
  if (data.cor === undefined || data.cor === null) {
    ctx.addIssue({
      code: ZodIssueCode.custom,
      message: 'Selecione uma cor!',
      path: ['cor'],
    });
  }
  if (data.corValor === undefined || data.corValor.length === 0) {
    ctx.addIssue({
      code: ZodIssueCode.custom,
      message: 'Selecione uma cor!',
      path: ['cor'],
    });
  }
});

/**
 * CadastroCoresForm
 */

export type CadastroCoresForm = z.infer<typeof CadastroCoresSchema>;
